import { render, staticRenderFns } from "./LicenseAssignment.vue?vue&type=template&id=cf55edbe"
import script from "./LicenseAssignment.vue?vue&type=script&lang=js"
export * from "./LicenseAssignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports